// extracted by mini-css-extract-plugin
export default {"container":"TC-z","dimension":"UC-z","dimensionLabels":"VC-z"};